/*=========================================================================================
  File Name: moduleCompteGetters.js
  Description: Compte Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {

}